import React from 'react';
import App from './App'
import ReactDOM from 'react-dom';
import './assets/main.css';



ReactDOM.render(<App />, document.getElementById('root'));


